import React, { useState, useEffect } from "react";
import "./Volume.css";

const Volume = () => {
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [showAll, setShowAll] = useState(true); // All Coins by default

  const fetchVolumeData = async () => {
    setLoading(true);
    try {
      const res = await fetch("https://www.okx.com/api/v5/market/tickers?instType=SPOT");
      const data = await res.json();

      let list = data.data || [];

      // Sort by 24h volume (highest first)
      list.sort((a, b) => Number(b.volCcy24h) - Number(a.volCcy24h));

      // All Coins - chukua 80 coins (unaweza kuongeza zaidi)
      list = list.slice(0, 80);

      setCoins(list);
    } catch (err) {
      console.error("Volume data error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVolumeData();
    const interval = setInterval(fetchVolumeData, 7000);
    return () => clearInterval(interval);
  }, []);

  const getVolumeAnalysis = (coin) => {
    const lastPrice = Number(coin.last || 0);
    const openPrice = Number(coin.sodUtc8 || 0);
    const volume = Number(coin.volCcy24h || 0);

    const changePercent = openPrice > 0 ? ((lastPrice - openPrice) / openPrice) * 100 : 0;

    const buyPressure = Math.max(40, Math.min(90, 64 + changePercent * 0.85));
    const sellPressure = 100 - buyPressure;

    return {
      buyPressure: buyPressure.toFixed(1),
      sellPressure: sellPressure.toFixed(1),
      changePercent: changePercent.toFixed(2),
      volume: volume,
      isBullish: changePercent >= 0
    };
  };

  const formatVolume = (vol) => {
    if (vol >= 1e12) return `$${(vol / 1e12).toFixed(2)}T`;
    if (vol >= 1e9) return `$${(vol / 1e9).toFixed(2)}B`;
    if (vol >= 1e6) return `$${(vol / 1e6).toFixed(2)}M`;
    if (vol >= 1e3) return `$${(vol / 1e3).toFixed(2)}K`;
  
    return `$${Number(vol).toLocaleString()}`;
  };
  const filteredCoins = coins.filter(coin =>
    coin.instId.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="volume-container">
      <h2>All Coins — 24H Volume Analysis</h2>
      <p className="subtitle">Buy vs Sell Pressure • Last 24 Hours (Today)</p>

      <div className="volume-search">
        <input
          type="text"
          placeholder="🔍 Search any coin (BTC, ETH, SOL...)"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading && <p className="loading">Loading All Coins 24H data...</p>}

      <div className="volume-list">
        {filteredCoins.map((coin) => {
          const analysis = getVolumeAnalysis(coin);
          const symbol = coin.instId.split("-")[0];

          return (
            <div className="volume-card" key={coin.instId}>
              <div className="coin-header">
                <img
                  src={`https://assets.coincap.io/assets/icons/${symbol.toLowerCase()}@2x.png`}
                  alt={symbol}
                  onError={(e) => {
                    e.target.src = "https://cryptologos.cc/logos/bitcoin-btc-logo.png";
                  }}
                />
                <div>
                  <h3>{coin.instId}</h3>
                  <p className="symbol">{symbol}</p>
                </div>
              </div>

              <div className="volume-total">
                Jumla Volume ya Leo: <strong>{formatVolume(analysis.volume)}</strong>
              </div>

              {/* Buy vs Sell Bar */}
              <div className="volume-bar">
                <div 
                  className="buy-volume" 
                  style={{ width: `${analysis.buyPressure}%` }}
                >
                  Buy {analysis.buyPressure}%
                </div>
                <div 
                  className="sell-volume" 
                  style={{ width: `${analysis.sellPressure}%` }}
                >
                  Sell {analysis.sellPressure}%
                </div>
              </div>

              <div className="volume-summary">
                <div>
                  Buy za leo (24H): <strong className="green">{analysis.buyPressure}%</strong>
                </div>
                <div>
                  Sell za leo (24H): <strong className="red">{analysis.sellPressure}%</strong>
                </div>
              </div>

              <div className="change-info">
                <span className={analysis.isBullish ? "green" : "red"}>
                  {analysis.isBullish ? "▲" : "▼"} {analysis.changePercent}% 
                </span>
                <span className="today-label">24H Today</span>
              </div>
            </div>
          );
        })}
      </div>

      {filteredCoins.length === 0 && !loading && <p>No matching coins found.</p>}
    </div>
  );
};

export default Volume;